import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router';
import { Title, Button, TagsButtons } from '.';
var AlbumHeader = function (props) {
    var label = props.label;
    var _a = useState(false), showMore = _a[0], setShowMore = _a[1];
    var description = useRef(null);
    var history = useHistory();
    return (React.createElement("div", { className: "LabelHeader" },
        React.createElement("div", { className: "background-image", style: { background: "linear-gradient(45deg, " + label.gradient_color + ")" } },
            React.createElement("div", { className: "content-wrapper" },
                React.createElement("div", { className: "album-wrapper" },
                    React.createElement("img", { className: "album-cover", src: label.logo_url, alt: "album cover" })),
                React.createElement("div", { className: "content-container" },
                    React.createElement(Title, { titleText: label.name, fontSize: '3rem', margins: '0 0 1rem 0' }),
                    React.createElement("div", { className: "tags-container" },
                        React.createElement(Button, { className: 'view-all-btn', buttonText: 'View All Packs', onClick: function () { return history.push('/labelpacks/' + label.name); } }),
                        React.createElement(TagsButtons, { buttons: props.tags.map(function (tag) {
                                return {
                                    buttonText: tag.name,
                                    buttonTextRight: tag.sound_count,
                                    selected: (props.selectedTags || []).includes(tag.id) || (props.selectedTags || []).includesLowercase(tag.name),
                                    onClick: function () {
                                        props.onTagClick(tag);
                                    },
                                    rightTextFontSize: '1.3rem'
                                };
                            }) })),
                    React.createElement("div", { className: 'subtext' },
                        React.createElement("span", { className: "description " + (showMore ? 'un-truncate' : ''), ref: description, style: showMore && description.current ? { height: description.current.scrollHeight } : {} }, label.description),
                        description.current && description.current.scrollHeight > 63 ?
                            React.createElement("span", { className: "showMore", onClick: function () {
                                    if (showMore)
                                        setShowMore(false);
                                    else
                                        setShowMore(true);
                                } }, showMore ? 'READ LESS' : 'READ MORE')
                            :
                                null))))));
};
export default AlbumHeader;
//# sourceMappingURL=LabelHeader.js.map